import DateColumnFilter from 'components/atoms/date-column-filter'
import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import MerchantInboundTypeBadge from 'domains/merchant-inbound/atoms/inbound-type-badge'
import MerchantInboundReceivedStatusBadge from 'domains/merchant-inbound/atoms/received-status-badge'
import MerchantInboundScheduleBadge from 'domains/merchant-inbound/atoms/schedule-badge'
import {
  INBOUND_TYPE,
  RECEIVED_STATUS,
  CURATION_STATUS,
  SCHEDULED,
  INBOUND_PROCESS_STATUS
} from 'domains/merchant-inbound/constants'
import MerchantBadge from 'domains/merchant/atoms/merchant-badge'
import { MERCHANT_TYPE } from 'domains/merchant/constants'
import React from 'react'
import TimeUtil from 'utils/time-util'
import MerchantInboundCurationStatusBadge from 'domains/merchant-inbound/atoms/curation-status-badge'
import MerchantInboundProcessStatusBadge from 'domains/merchant-inbound/atoms/inbound-process-status-badge'
import PropTypes from 'prop-types'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}

/**
 * Merchant Inbound Table Columns
 */
const merchantInboundTableColumns = ({
  buttonText,
  buttonColour,
  isButtonDisabled,
  onButtonClick
}) => {

  const MerchantTypeFilter = ({ column }) => {
    const options = Object.keys(MERCHANT_TYPE).map((key) => (
      {
        label : MERCHANT_TYPE[key],
        value : MERCHANT_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  MerchantTypeFilter.propTypes = filterPropTypes

  const InboundTypeFilter = ({ column }) => {
    const options = Object.keys(INBOUND_TYPE).map((key) => (
      {
        label : INBOUND_TYPE[key],
        value : INBOUND_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  InboundTypeFilter.propTypes = filterPropTypes

  const ReceivedStatusFilter = ({ column }) => {
    const options = Object.keys(RECEIVED_STATUS).map((key) => (
      {
        label : RECEIVED_STATUS[key],
        value : RECEIVED_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  ReceivedStatusFilter.propTypes = filterPropTypes

  const CurationStatusFilter = ({ column }) => {
    const options = Object.keys(CURATION_STATUS).map((key) => (
      {
        label : CURATION_STATUS[key],
        value : CURATION_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  CurationStatusFilter.propTypes = filterPropTypes

  const ScheduledStatusFilter = ({ column }) => {
    const labelMap = {
      [SCHEDULED.YES] : 'scheduled',
      [SCHEDULED.NO]  : 'unscheduled'
    }
    const options  = Object.keys(SCHEDULED).map((key) => (
      {
        label : labelMap[SCHEDULED[key]],
        value : SCHEDULED[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  ScheduledStatusFilter.propTypes = filterPropTypes

  const InboundProcessStatusFilter = ({ column }) => {
    const options = Object.keys(INBOUND_PROCESS_STATUS).map((key) => (
      {
        label : INBOUND_PROCESS_STATUS[key],
        value : INBOUND_PROCESS_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  InboundProcessStatusFilter.propTypes = filterPropTypes

  // Custom Cell
  // Used to modify the cell in specific columns
  const MerchantTypeCell = (row) => <MerchantBadge merchant_type={ row.cell.value } />

  const InboundTypeCell = (row) => <MerchantInboundTypeBadge inbound_type={ row.cell.value } />

  const ReceivedStatusCell = (row) => <MerchantInboundReceivedStatusBadge received_status={ row.cell.value } />

  const ScheduledStatusCell = (row) => <MerchantInboundScheduleBadge scheduled={ row.cell.value } />

  const CurationStatusCell = (row) => <MerchantInboundCurationStatusBadge curation_status={ row.cell.value } />

  const InboundProcessStatusCell = (row) => <MerchantInboundProcessStatusBadge inboundProcessStatus={ row.cell.value } />

  const DateCell = (row) => TimeUtil.format(row.cell.value)

  const ActionCell = ({ cell: { row } }) => {
    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <RowButton
        data={ row.original }
        color={ buttonColour }
        disabled={ disabled }
        onClick={ onButtonClick }
        text={ buttonText }
      />
    )
  }

  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header  : 'Merchant Inbound',
        columns : [
          {
            Header         : 'ID',
            accessor       : 'id',
            disableFilters : true
          },
          {
            Header   : 'Code',
            accessor : 'code'
          },
          {
            Header   : <>Inbound <br/> Type</>,
            accessor : 'inbound_type',
            id       : 'inbound_type',
            Filter   : InboundTypeFilter,
            Cell     : InboundTypeCell
          },
          {
            Header   : <>Requested<br/>Date</>,
            accessor : 'requested_date',
            id       : 'requested_date',
            Filter   : DateColumnFilter,
            Cell     : DateCell
          },
          {
            Header   : <>Received<br/> Status</>,
            accessor : 'received_status',
            Cell     : ReceivedStatusCell,
            Filter   : ReceivedStatusFilter
          },
          {
            Header         : <>Inbound<br/> Quantity</>,
            accessor       : 'quantity',
            disableFilters : true
          },
          {
            Header         : <>Received<br/>Qty</>,
            accessor       : 'received_quantity',
            disableFilters : true
          },
          {
            Header   : <>Received<br/>Date</>,
            accessor : 'received_date',
            id       : 'received_date',
            Filter   : DateColumnFilter,
            Cell     : DateCell
          },
          {
            Header   : <>Live Process<br/> Status</>,
            accessor : 'inbound_process_status',
            Cell     : InboundProcessStatusCell,
            Filter   : InboundProcessStatusFilter
          }
        ]
      },

      {
        Header  : 'Merchant',
        columns : [
          {
            Header   : 'Name',
            accessor : 'merchant.name',
            id       : 'merchant_name'
          },
          {
            Header   : 'Code',
            accessor : 'merchant.code',
            id       : 'merchant_code'
          },
          {
            Header         : 'Email',
            accessor       : 'merchant.email',
            id             : 'merchant_email',
            disableFilters : true
          },
          {
            Header   : 'Type',
            accessor : 'merchant.merchant_type',
            id       : 'merchant_type',
            Cell     : MerchantTypeCell,
            Filter   : MerchantTypeFilter
          }
        ]
      },
      {
        Header  : 'Curation',
        columns : [
          {
            Header   : <>Curation<br/> Status</>,
            accessor : 'curation.status',
            id       : 'curation_status',
            Cell     : CurationStatusCell,
            Filter   : CurationStatusFilter
          }
        ]
      },
      {
        Header  : 'Pickup',
        columns : [
          {
            Header   : 'Scheduled',
            accessor : 'pickup.scheduled',
            id       : 'scheduled',
            Cell     : ScheduledStatusCell,
            Filter   : ScheduledStatusFilter
          },
          {
            Header   : <>Scheduled <br/>date</>,
            accessor : 'pickup.scheduled_at',
            id       : 'scheduled_at',
            Filter   : DateColumnFilter,
            Cell     : DateCell
          }
        ]
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

export default merchantInboundTableColumns
